import React, { Component } from 'react'

/**
 * On Social Hybrid apps we require #yvexternal to launch in native browser.
 * We are override the click method of the social buttons to inject this...
 */
export const asHybridButton = SButton => {
    return class HButton extends SButton {
        constructor(props) {
            super(props)
            this.oldConstructUrl = this.constructUrl
            this.constructUrl = this.yvConstructUrl.bind(this)
        }
        yvConstructUrl() {
            return this.oldConstructUrl() + '#yvexternal'
        }
    }
}
